import React, { useState, useMemo } from 'react';
import TargetCard from './TargetCard';
import '../../styles/v4-theme.css';

/**
 * TargetCardsGrid Component
 * Displays a filterable grid of target cards
 */
const TargetCardsGrid = ({ targets = [], onTargetClick, selectedTargetId, onTimestampClick }) => {
  // No internal filtering - parent component handles tab filtering now

  if (targets.length === 0) {
    return (
      <div className="v4-cards-container">
        <div className="v4-empty-state">
          <div className="v4-empty-state-icon">🔍</div>
          <div className="v4-empty-state-title">No Targets Detected</div>
          <div className="v4-empty-state-description">
            This analysis did not detect any targets in the video. Try running a new analysis with different settings.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="v4-cards-container">
      {/* Cards Grid */}
      <div className="v4-cards-grid">
        {targets.map(target => (
          <TargetCard
            key={target.id}
            target={target}
            onClick={onTargetClick}
            selected={target.id === selectedTargetId}
            onTimestampClick={onTimestampClick}
          />
        ))}
      </div>

      {/* Count */}
      {targets.length > 0 && (
        <div style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: 'var(--text-sm)', marginTop: 'var(--space-4)' }}>
          {targets.length} {targets.length === 1 ? 'target' : 'targets'}
        </div>
      )}
    </div>
  );
};

export default TargetCardsGrid;

